export const GIT_BRANCH = "master"
export const GIT_HASH = "5f4409f3f0fcb362ef5f993ec5f1bcd35e329ed7"
export const BUILD_NUM = "master.2023.10.12.03"
export const THEME_COLOR = "#808080"
export const PRIMARY_COLOR = "#ffffff"
export const TERTIARY_COLOR = "#414142"
export const ASSETS_BASE_URL = "https://web-order.flipdish.co/client/productionwlbuild/latest/"
export const DEFAULT_API_URL = "https://api.flipdish.co/"
export const DEFAULT_PATH_EMBEDDED = "https://web-order.flipdish.co/production/embedded/latest/index.html"
